import axios from '../requester';
import { LINB_API } from 'common/constants/api-urls';

export const getUsers = async ({
  limit,
  offset = 0,
  orderBy = 'name',
  orderDir = 'ASC',
  search = '',
  searchFields = ['name', 'email']
} = {}) => {
  const params = {
    limit,
    offset,
    orderBy,
    orderDir,
    ...(search && { search }),
    ...(searchFields && { search_fields: searchFields })
  };
  return axios.get(LINB_API.USERS_SERVICE.USERS, { params });
};
